export const POST_CHECKOUT_REQUEST="POST_CHECKOUT_REQUEST";
export const POST_CHECKOUT_SUCCESS = "POST_CHECKOUT_SUCCESS";
export const POST_CHECKOUT_FAILED = "POST_CHECKOUT_FAILED";
